const BACKEND_PREFIXES = [
  "/admin",
  "/partner",
  "/account",
  "/glemt-adgangskode",
  "/nulstil-adgangskode",
  "/lead-status",
  "/feedback",
];

export function isBackendPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  // The wizard root (exact /tilbud) is a marketing page; only /tilbud/:token is backend.
  if (pathname.startsWith("/tilbud/")) return true;
  return BACKEND_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
